import { Component } from '@angular/core';
// import packageJson from '../../../../../package.json';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
})
export class InfoComponent {
  // public name: string = packageJson.name;
  // public version: string = packageJson.version;
}
